/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// Los tres declaran el pin de audio P8, que es el que trae la placa.

const AUDIO_PIN_SETUP = 'pins.setAudioPin(AnalogPin.P8)\n';

export const BHOOT_piezo_buzzer = (block, generator) => {
  const piano = block.getFieldValue('PIANO') || {};

  generator.definitions_['BHOOT_piezo_buzzer'] = AUDIO_PIN_SETUP;

  // La octava 3 multiplica por 4, no por 3: los multiplicadores reales son 1/2/4, y así
  // suena igual que el modal y que la capa Arduino (660 Hz en la nota por defecto).
  return `music.playTone(${(piano.basePitch * (piano.octave === 3 ? 4 : piano.octave)) || 131}, ${piano.duration || 1000})\n`;
};

export const BHOOT_piezo_buzzer_variable = (block, generator) => {
  const tone = generator.valueToCode(block, 'VAR', generator.ORDER_NONE);
  const duration = generator.valueToCode(block, 'DURATION', generator.ORDER_NONE);

  generator.definitions_['BHOOT_piezo_buzzer'] = AUDIO_PIN_SETUP;

  return `music.playTone(${tone}, ${duration})\n`;
};

export const BHOOT_piezo_buzzerno = (block, generator) => {
  generator.definitions_['BHOOT_piezo_buzzer'] = AUDIO_PIN_SETUP;

  return 'music.stopAllSounds()\n';
};

// Los dos bloques manejan la misma tira de neopixels, así que comparten la
// clave de definición por pin: declarar la tira dos veces no compila.
const neopixelStrip = (generator, pin) => {
  generator.definitions_[`bhoot_salidas_led_rgb_${pin}`] = `let strip_${pin} = neopixel.create(DigitalPin.${pin}, 6, NeoPixelMode.RGB)\n`;
};

export const BHOOT_led_rgb = (block, generator) => {
  const colours = [1, 2, 3, 4, 5, 6]
    .map((i) => generator.valueToCode(block, `COLOUR${i}`, generator.ORDER_ATOMIC) || 0);
  const pin = block.getFieldValue('NPIN') || '0';

  neopixelStrip(generator, pin);

  const pixels = colours
    .map((colour, i) => `strip_${pin}.setPixelColor(${i}, neopixel.rgb(${colour}))`)
    .join('\n');

  return `\n${pixels}\nstrip_${pin}.show()\ncontrol.waitMicros(300)\n`;
};

export const BHOOT_salidas_led_rgb = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const r = generator.valueToCode(block, 'DATOINR', generator.ORDER_ATOMIC) || 0;
  const g = generator.valueToCode(block, 'DATOING', generator.ORDER_ATOMIC) || 0;
  const b = generator.valueToCode(block, 'DATOINB', generator.ORDER_ATOMIC) || 0;

  neopixelStrip(generator, pin);

  return `\n  strip_${pin}.showColor(neopixel.rgb(${r}, ${g}, ${b}))\n`;
};
